<div class="row page-header">
    <div class="col-12">
        <h1>Leadership Team Job Visits <small>Track leadership visits to active jobs</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Visits</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-leadership-team-visits-dashboard (addForJob)="onAddForJob($event)"></app-leadership-team-visits-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-leadership-team-visits-list></app-leadership-team-visits-list>
    </div>
</div>
